import { ExchangeRateClient } from '@src/exchangeRateManager/services/ExchangeRateClient';
import { useQuery } from '@tanstack/react-query';

export const LIST_EXCHANGE_RATE_QUERY_KEY = 'listExchangeRate';
export const useExchangeRate = () => {
  const { data, isLoading } = useQuery({
    queryKey: [LIST_EXCHANGE_RATE_QUERY_KEY],
    queryFn: ExchangeRateClient.list,
  });

  return { exchangeRates: data ?? [], isLoading };
};
